import { Typography } from "@mui/material";
import { useEffect } from "react";

import Modal from "../../../../global/Modal";
import { TextEditor } from "../../../../ui library/components/text-editors/client-notes-text-editor";
import HNSColors from "../../../../ui library/HNSColors";
import { useNoteEditor } from "../../hooks/useNotesEditor";
import { STRINGS } from "../../utils/strings";
import NoteTypeSelector from "../Fields/NoteTypeSelector";

import ModalActions from "./ModalActions";

export default function AddEditModal({
  mode = STRINGS.ADD_MODE,
  openModal,
  handleCloseModal,
  data,
  handleSubmit,
  userId,
  hideNoteTypeSelector = false,
  hideVisibilityInfo = false,
  useSimpleTitle = false,
}) {
  const {
    selectedNoteType,
    selectedNoteContent,
    disableButtons,
    reset,
    handleSave,
    handleTypeChange,
    handleContentChange,
    initializeModal,
  } = useNoteEditor({ mode, data, userId, handleSubmit, hideNoteTypeSelector });

  useEffect(() => {
    if (openModal) {
      initializeModal();
    }
  }, [openModal, initializeModal]);

  const headerLabel = hideNoteTypeSelector
    ? STRINGS.INTERNAL_LABEL
    : selectedNoteType
      ? STRINGS.INTERNAL_LABEL
      : STRINGS.EXTERNAL_LABEL;
  const actionLabel = mode === STRINGS.ADD_MODE ? "Add" : "Edit";
  const modalTitle = useSimpleTitle
    ? `${actionLabel} Note`
    : `${actionLabel} ${headerLabel} Note`;

  return (
    <Modal open={openModal} onClose={handleCloseModal} maxWidth="md">
      <div className="p-6 flex flex-col gap-4">
        <Typography
          className="text-[32px] font-semibold"
          style={{ color: HNSColors.primary[500] }}
        >
          {modalTitle}
        </Typography>

        <NoteTypeSelector
          selectedNoteType={selectedNoteType}
          setSelectedNoteType={handleTypeChange}
          hideSelector={hideNoteTypeSelector}
          hideVisibilityInfo={hideVisibilityInfo}
        />

        <TextEditor
          value={selectedNoteContent}
          onChangeHandler={handleContentChange}
        />

        <ModalActions
          onReset={reset}
          onSave={handleSave}
          disabled={disableButtons()}
          mode={mode}
        />
      </div>
    </Modal>
  );
}
